import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as string | null;

/**
 * # bufferDeliveryTimeFetchedEstimate
 *
 * We use this for ASAP estimates to let the user know the what the fetched
 * estimate for ASAP is, while we send the "asap" to backend in validate cart
 * and other thunks.
 *
 */
const slice = createSlice({
  name: '$bufferDeliveryTimeFetchedEstimate',
  initialState,
  reducers: {
    setBufferDeliveryTimeFetchedEstimate(
      state,
      action: PayloadAction<string | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, () => {
      return initialState;
    });
  },
});

export const { setBufferDeliveryTimeFetchedEstimate } = slice.actions;
export default slice.reducer;
